export const isObjectEmpty = (obj, excludeKeys = []) => {
    return Object.entries(obj)
        .filter(([key]) => !excludeKeys.includes(key)) // Exclude specified keys
        .every(([, value]) => !value); // Check if all remaining values are falsy
};